import { Dialog, DialogActions, DialogContent } from "@mui/material"
import type { FC } from "react"

import { ScannedGoodsReceiptPalletCard } from "../../components/ScannedGoodsReceiptPalletCard"

import { Button } from "@/components/common/Button"
import type { GoodsReceiptPallet } from "@/graphql/codegen/graphql"
import { useAppView } from "@/hooks/useAppView"
import type { DestinationOverride } from "@/screens/WarehouseReceiving/components/GoodsReceiptPalletsTable/schemas/overrideDestinationSchema"

interface GoodsReceiptPalletDialogProps {
  pallet: GoodsReceiptPallet
  onClose: () => void
  onQrPrint: (pallet: GoodsReceiptPallet) => void
  onDestinationOverride?: (pallet: GoodsReceiptPallet, override: DestinationOverride) => Promise<void>
}

export const GoodsReceiptPalletDialog: FC<GoodsReceiptPalletDialogProps> = ({
  pallet,
  onClose,
  onQrPrint,
  onDestinationOverride,
}) => {
  const { isTabletView } = useAppView()

  return (
    <Dialog
      open
      maxWidth={!isTabletView ? "md" : undefined}
      fullWidth={!isTabletView}
      fullScreen={isTabletView}
      onClose={onClose}
      data-testid='goods-receipt-pallet-dialog'
    >
      <DialogContent className={`pb-0 ${isTabletView ? "px-6 pt-6" : "px-10 pt-10"}`}>
        <ScannedGoodsReceiptPalletCard
          pallet={pallet}
          repeatedScan={false}
          scanCount={1}
          pallets={[]}
          destinationOverrides={new Map()}
          onDestinationOverride={onDestinationOverride}
          onQrPrint={() => onQrPrint(pallet)}
        />
      </DialogContent>
      <DialogActions className={isTabletView ? "p-6" : "justify-end px-10 pb-10 pt-6"}>
        <Button
          appearance='outlined'
          variant='primary'
          className={isTabletView ? "flex-1" : ""}
          onClick={onClose}
          data-testid='close-dialog-button'
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}
